import { ControlledTextField, ErrorMessage } from '@/src/ui';
import type { Control, FieldErrors } from 'react-hook-form';
import type { QtiGraphingQuestionDTO } from '@/src/lib';

interface GraphAxisEditorProps {
    control: Control<QtiGraphingQuestionDTO>;
    errors: FieldErrors<QtiGraphingQuestionDTO>;
}

export default function GraphAxisEditor({ control, errors }: GraphAxisEditorProps) {
    return (
        <div className="border rounded p-4 bg-white space-y-4 max-w-xl">
            <div className="font-semibold text-sm">Axis / Grid Settings</div>

            <div className="grid grid-cols-6 gap-4 text-sm">
                <div className="flex flex-col gap-2">
                    <ControlledTextField
                        name="axis.minX"
                        control={control}
                        label="Min X"
                        type="number"
                        error={errors.axis?.minX}
                    />
                </div>

                <div className="flex flex-col gap-2">
                    <ControlledTextField
                        name="axis.maxX"
                        control={control}
                        label="Max X"
                        type="number"
                        error={errors.axis?.maxX}
                    />
                </div>

                <div className="flex flex-col gap-2">
                    <ControlledTextField
                        name="axis.minY"
                        control={control}
                        label="Min Y"
                        type="number"
                        error={errors.axis?.minY}
                    />
                </div>

                <div className="flex flex-col gap-2">
                    <ControlledTextField
                        name="axis.maxY"
                        control={control}
                        label="Max Y"
                        type="number"
                        error={errors.axis?.maxY}
                    />
                </div>

                <div className="flex flex-col gap-2">
                    <ControlledTextField
                        name="axis.snapX"
                        control={control}
                        label="Snap X"
                        type="number"
                        error={errors.axis?.snapX}
                    />
                </div>

                <div className="flex flex-col gap-2">
                    <ControlledTextField
                        name="axis.snapY"
                        control={control}
                        label="Snap Y"
                        type="number"
                        error={errors.axis?.snapY}
                    />
                </div>
            </div>

            <ErrorMessage error={errors.axis as any} />
        </div>
    );
}
